/**
 * Classify Smoke Drive items for in-pane preview (PDF, image, text).
 */

const IMAGE_EXT = /\.(png|jpe?g|gif|webp|bmp|svg)$/i;
const PDF_EXT = /\.pdf$/i;
const TEXT_EXT = /\.(txt|csv|json|md|log|xml|html?)$/i;

function fileNameOf(item) {
    return String(item?.originalFileName || item?.name || '').trim();
}

function contentTypeOf(item) {
    return String(item?.contentType || '').toLowerCase();
}

/**
 * @param {object} item
 * @returns {'image' | 'pdf' | 'text' | 'none'}
 */
export function classifyDrivePreview(item) {
    if (!item || item.type === 'folder' || item.trashed) return 'none';
    const type = contentTypeOf(item);
    const name = fileNameOf(item);
    if (type.startsWith('image/') || IMAGE_EXT.test(name)) return 'image';
    if (type === 'application/pdf' || PDF_EXT.test(name)) return 'pdf';
    if (
        type.startsWith('text/')
        || type === 'application/json'
        || type === 'application/xml'
        || TEXT_EXT.test(name)
    ) {
        return 'text';
    }
    return 'none';
}

export const DRIVE_TEXT_PREVIEW_MAX_BYTES = 400 * 1024;

/** Soft cap for in-pane PDF / image blob preview (desk memory). */
export const DRIVE_MEDIA_PREVIEW_MAX_BYTES = 40 * 1024 * 1024;

